<div class="backDrop" *ngIf="show">
	<div class="modal-dialog modal-lg update-modal">
		<div class="modal-content">
			<!-- Modal Header -->
			<div class="modal-header">
				<h4 class="modal-title">{{ title }}</h4>
			</div>

			<!-- Modal body -->
			<div class="modal-body" *ngIf="(applications$ | async)">
				<dx-tooltip target="#icon-textbox" showEvent="dxhoverstart" hideEvent="dxhoverend">
					<p style="text-align: left;">
						A font awesome icon name should be entered without the prefix.<br>
						So for instance <strong>file</strong> instead of <strong>fa-file</strong>.
					</p>
				</dx-tooltip>

				<label class="form-label">Connected app type</label>
				<dx-select-box [dataSource]='applications$ | async' displayExpr="displayName" valueExpr="id"
					(onValueChanged)="loadApplicationSettings($event)"></dx-select-box>
				<div *ngIf="applicationParamsChange$ | async">
					<form [formGroup]="applicationTypeForm">
						<div *ngIf="applicationParams.parameters.length > 0">
							<label class="form-label" style="width: 60px;">{{ 'CONNECTEDAPP.REQUIRED' |
								translate:locale.language }}</label>
							<label class="form-label" style="width: 60px; padding-left: 5px;">Hidden</label>
							<label class="form-label" style="width: calc(20% - 60px);">{{ 'CONNECTEDAPP.PARAMETERTYPE' | translate:locale.language
								}}</label>
							<label class="form-label" style="width: calc(20% - 20px);">{{ 'CONNECTEDAPP.PARAMETER' | translate:locale.language }}</label>
							<label style="width: calc(20% - 20px);" class="form-label">Default value</label>
							<label style="width: calc(20% - 40px);" class="form-label">Field name</label>
							<label style="margin-left: 20px;" class="form-label">Rich text</label>
						</div>
						<div style="padding-top: 10px;" *ngIf="applicationParams.parameters.length == 0"></div>
						<div *ngFor="let parameter of applicationParams.parameters" class="form-row form-item">
							<dx-check-box style="width: 16px; height: 16px; margin-right: 27px; margin-left: 17px;"
								[(value)]="parameter.isRequired"></dx-check-box>
							<dx-check-box style="width: 16px; height: 16px; margin-right: 27px; margin-left: 17px;"
								[(value)]="parameter.hidden"></dx-check-box>
							<dx-select-box style="width: calc(20% - 70px);" as-validator [formControlName]="parameter.id + '_type'"
								[dataSource]="parameterTypes" displayExpr="text" valueExpr="id" [(value)]="parameter.type"></dx-select-box>
							<dx-text-box as-validator [formControlName]="parameter.id + '_name'"
								style="width: calc(20% - 30px); margin-left: 10px;" placeholder="Parameter name" [(value)]="parameter.name">
							</dx-text-box>
							<dx-text-box as-validator [formControlName]="parameter.id + '_defaultValue'"
								style="width: calc(20% - 30px); margin-left: 10px;" placeholder="Default value"
								[(value)]="parameter.defaultValue">
							</dx-text-box>
							<dx-select-box as-validator [formControlName]="parameter.id + '_fieldName'"
								style="width: calc(20% - 30px); margin-left: 10px;" placeholder="Field name" [(value)]="parameter.fieldName"
								[items]="applicationLoginFields">
							</dx-select-box>
							<dx-text-box as-validator [formControlName]="parameter.id + '_richText'"
								style="width: calc(20% - 30px); margin-left: 10px;" placeholder="Rich text" [(value)]="parameter.richText">
							</dx-text-box>
							<div [hidden]="applicationParams.parameters.length === 1" (click)="removeParameter(parameter.id)" class="far fa-times text-danger"
								style="margin-left: 10px; cursor: pointer;"></div>
						</div>
						<button class="btn btn-sm btn-primary add-button" (click)="addParameter()">{{
							'CONNECTEDAPP.ADDPARAMETER' | translate:locale.language }}</button>
						<br>

						<label class="form-label">Global parameters</label>
						<div class="container row">
							<div class="form-check">
								<label style="padding-right: 15px" class="label mt-1">Enable OAuth</label>
								<dx-check-box [(value)]="isOAuthEnabled"></dx-check-box>
							</div>
						</div>
					</form>
				</div>
			</div>

			<!-- Modal footer -->
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" (click)="save()">
					Save
				</button>
				<button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="cancel()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
